import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { getDomainSlug } from "../utils/tenant";

const useOrganization = () => {
  const { currentOrganization } = useSelector(
    (state: RootState) => state.organization,
  );

  const currentDomainSlug = getDomainSlug();
  const isCoachDomain = currentDomainSlug === "coach";

  return {
    currentDomainSlug,
    currentOrganization,
    isCoachDomain,
  };
};

export default useOrganization;
